var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentMethod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 13.105 0.895 14 2 14H14C15.105 14 16 13.105 16 12V7H0V12Z",
    fill: "#FF70433"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H2C0.895 2 0 2.895 0 4V6H16V4C16 2.895 15.105 2 14 2Z",
    fill: "#FF7043"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethod);
export default __webpack_public_path__ + "static/media/payment_method.a0f940ae.svg";
export { ForwardRef as ReactComponent };